import { Button } from '@/components';
import { DateTime } from '@/types';
import { Column, Element, Icon, Row } from '@vuddy/components';
import { formatMonthDate } from '@vuddy/utils';
import * as styles from './gachaTicketButton.css';
import { GachaTicketButtonProps } from './selectGachaCta';

export const GachaTicketButton = ({
  state,
  label,
  subLabel,
  onClick,
  plannedStartAt,
}: GachaTicketButtonProps) => {
  const isActive = state === 'active';
  const contentColor = isActive ? 'primary' : 'disabled';

  const content = subLabel ? (
    <Column alignItems="center">
      <Row gap="gap_xs" alignItems="center">
        <Icon name="FILL_TICKET" color={contentColor} size="16px" />
        <Element typography="bodyBaseAccent" color={contentColor}>
          {label}
        </Element>
      </Row>
      <Element typography="bodyXs" color={contentColor}>
        {subLabel}
      </Element>
    </Column>
  ) : (
    <Row gap="gap_xs" alignItems="center">
      <Icon name="FILL_TICKET" color={contentColor} size="16px" />
      <Element typography="bodyBaseAccent" color={contentColor}>
        {label}
      </Element>
    </Row>
  );

  return (
    <Column
      className={styles.wrapper}
      width="100%"
      position={plannedStartAt ? 'relative' : undefined}>
      {isActive ? (
        <Button variant="solidWhite" size="large" fullWidth onClick={onClick}>
          {content}
        </Button>
      ) : (
        <Button variant="solidTertiary" size="large" fullWidth disabled>
          {content}
        </Button>
      )}
      {plannedStartAt ? <PlannedTimerBadge startAt={plannedStartAt} /> : null}
    </Column>
  );
};

const PlannedTimerBadge = ({ startAt }: { startAt: DateTime }) => (
  <Column
    position="absolute"
    width="100%"
    alignItems="center"
    className={styles.timer}>
    <Row
      backgroundColor="black"
      borderRadius="radius_large"
      paddingY="padding_4xs"
      paddingX="padding_xs"
      gap="gap_small">
      <Icon name="OUTLINE_TIMER" color="whitePrimary" size="20px" />
      <Element typography="bodyXs" color="whitePrimary">
        오픈 {formatMonthDate(startAt)}
      </Element>
    </Row>
  </Column>
);
